import { type FC } from 'react';
import { type User } from '@/api/admin/user';
import { UiSimpleGrid, UiStack, UiText } from '@/lib/ui';

export interface PersonalInfoSectionProps {
  user: User
}

const InfoField: FC<{ label: string; value?: string | null }> = ({ label, value }) => {
  return (
    <UiStack>
      <UiText color={'text.secondary'}>{label}</UiText>
      <UiText>{value || 'N/A'}</UiText>
    </UiStack>
  );
};

const PersonalInfoSection: FC<PersonalInfoSectionProps> = ({ user }) => {
  const formatGender = (gender?: string | null) => {
    if (!gender) return 'N/A';
    if (gender === 'not_saying') return 'Prefer not to say';
    return gender.charAt(0).toUpperCase() + gender.slice(1);
  };

  return (
    <UiSimpleGrid columns={4} gap={8}>
      <InfoField label="Phone" value={user.phone} />
      <InfoField label="Company" value={user.company} />
      <InfoField label="Job Title" value={user.jobTitle} />
      <InfoField label="Location" value={user.location} />
      <InfoField label="Pronoun" value={user.pronoun} />
      <InfoField label="Gender" value={formatGender(user.gender)} />
      <InfoField label="CC Email Addresses" value={user.emailCcAddresses} />
      <InfoField label="Company Website" value={user.companyWebsite} />
    </UiSimpleGrid>
  );
};

export default PersonalInfoSection;